import {ClauseExtensionType,IClauseExtensionMySuffix} from 'src/app/shared/model//clause-extension-my-suffix.model';
import {IPolicyMySuffix} from 'src/app/shared/model/policy-my-suffix.model';
import {IScopeClauseSequenceInfo} from 'src/app/shared/model/scope-clause-sequence-info.model';
import {IRuleDeductableRateMySuffix,RuleDeductableRateMySuffix} from './rule-deductable-rate-my-suffix.model';
import {IRuleMySuffix} from './rule-my-suffix.model';
import {IStorageRuleMySuffix} from './storage-rule-mysuffix.model';

export const enum Product {
    MARINE_CARGO_INSURANCE = 'MARINE_CARGO_INSURANCE',
    SELLERS_INTEREST = 'SELLERS_INTEREST',
    BUYERS_INTEREST = 'BUYERS_INTEREST',
    STORAGE = 'STORAGE'
}

export const enum DeductibleType {
    FLAT_PERCENTAGE = 'FLAT_PERCENTAGE',
    FLAT_VALUE = 'FLAT_VALUE',
    MINIMUM_AND_MAXIMUM_VALUE_AND_A_PERCENTAGE='MINIMUM_AND_MAXIMUM_VALUE_AND_A_PERCENTAGE',
    NO_DEDUCTIBLE='NO_DEDUCTIBLE'
}

export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}

export enum ScopeType {
    GENERIC = 'GENERIC',
    ONE_TIME = 'ONE TIME'
}
export const enum PolicyMarketType{
    OPEN ='OPEN',
    GENERIC = 'GENERIC',
    SPOT ='SPOT'

}
export interface IDeductableTypes {
    clauseDeductableRates?: IRuleDeductableRateMySuffix[];
    extensionDeductableRates?: IRuleDeductableRateMySuffix[];
}

export class DeductableTypes implements IDeductableTypes {
    constructor(
        public clauseDeductableRates: IRuleDeductableRateMySuffix[] = [],
        public extensionDeductableRates: IRuleDeductableRateMySuffix[] = []
    ) {
        let clauseDeductableRate = new RuleDeductableRateMySuffix();
        this.clauseDeductableRates.push(clauseDeductableRate);

        let extensionDeductableRate = new RuleDeductableRateMySuffix();
        this.clauseDeductableRates.push(extensionDeductableRate);
    }
}

export interface IScopeClauseExtensionDeductable {
    id?: number;
    activeStatus?: ActiveStatus;
    type?: ClauseExtensionType;
    clauseDeductable?: IRuleDeductableRateMySuffix[];
    clauseExtensionList?: IClauseExtensionMySuffix[];

}
export class ScopeClauseExtensionDeductable implements IScopeClauseExtensionDeductable {

    constructor(
        public id?: number,
        public activeStatus?: ActiveStatus,
        public type?: ClauseExtensionType,
        public clauseDeductables?: IRuleDeductableRateMySuffix[],
        public clauseExtensionList: IClauseExtensionMySuffix[] = [],
    ) {
        this.activeStatus = ActiveStatus.ACTIVE;

        let clause = new RuleDeductableRateMySuffix();
        this.clauseDeductables.push(clause);

        let extension = new RuleDeductableRateMySuffix();
        this.clauseDeductables.push(clause);
    }
}

export interface IScopeMySuffix {
    id?: number;
    policyId?: number;
    scopeType?: ScopeType;
    maximumUseLimit?: number;
    effectiveDate?: Date;
    expiryDate?: Date;
    name?: string;
    product?: Product;
    deductibleType?: DeductibleType;
    description?: string;
    activeStatus?: ActiveStatus;
    clauses?: IClauseExtensionMySuffix[];
    extensions?: IClauseExtensionMySuffix[];
    streffectiveDate?: string;
    strexpiryDate?: string;
    policyScope?: IPolicyMySuffix;
    rules?: IRuleMySuffix[];
    storageRule?: IStorageRuleMySuffix[];
    scopeClauseSequenceInfoDTOs?: IScopeClauseSequenceInfo[];
    lastModifiedBy?: string;
    createdByUserRole?: string;
    lastModifiedByUserRole?: string;
    clauseDeductables?: IScopeClauseExtensionDeductable[];
    extensionDeductables?: IScopeClauseExtensionDeductable[];
    fromEffectiveDate?: string;
    typeOfClient?:any;
    changeTandCId?:number;
    policyMarketType ?:PolicyMarketType;
    isLOIRequired?: boolean;
    lastModifiedDate?: string;
    policyCurrency?: string;
    paymentTerm?: string;
    certificateCommonNumber?: string;
    isAnyDeclarationAvailable?: boolean;
    lineOfBusiness?: string;

}

export class ScopeMySuffix implements IScopeMySuffix {
    constructor(
        public id?: number,
        public policyId?: number,
        public scopeType?: ScopeType,
        public maximumUseLimit?: number,
        public effectiveDate?: Date,
        public expiryDate?: Date,
        public streffectiveDate?: string,
        public strexpiryDate?: string,
        public name?: string,
        public product?: Product,
        public deductibleType?: DeductibleType,
        public description?: string,
        public activeStatus?: ActiveStatus,
        public clauses?: IClauseExtensionMySuffix[],
        public extensions?: IClauseExtensionMySuffix[],
        public policyScope?: IPolicyMySuffix,
        public rules?: IRuleMySuffix[],
        public storageRule?: IStorageRuleMySuffix[],
        public scopeClauseSequenceInfoDTOs: IScopeClauseSequenceInfo[] = [],
        public lastModifiedBy?: string,
        public createdByUserRole?: string,
        public lastModifiedByUserRole?: string,
        public clauseDeductables: IScopeClauseExtensionDeductable[] = [],
        public extensionDeductables: IScopeClauseExtensionDeductable[] = [],
        public fromEffectiveDate?: string,
        public typeOfClient?:any,
        public changeTandCId?:number,
        public policyMarketType ?:PolicyMarketType,
        public isLOIRequired ?:boolean,
        public lastModifiedDate?: string,
        public policyCurrency?: string,
        public paymentTerm?:string,
        public certificateCommonNumber?: string,
        public lineOfBusiness?: string

    ) {
        this.activeStatus = ActiveStatus.ACTIVE;
        this.deductibleType = DeductibleType.FLAT_PERCENTAGE;
        this.isLOIRequired = false;
        this.description = '';
    }
}
